export default __webpack_public_path__ + "static/media/ArrowIconWhite.0a50b22d.svg";